<template>
  <li :class="{ [$style.containerMini]: miniBasket }">
    <h3 :class="$style.type" class="mb-0">{{ type }}</h3>
    <span :class="$style.quantityLabel">{{ $t('product.quantity') }}: </span>
    <span order-data-helper :class="$style.amount">{{ amount }}</span>
    <span v-if="!basketStatusIsOk && basketStatus !== ''" :class="$style.basketmessage">{{
      $t(`checkout.basket.status.${basketStatus}`)
    }}</span>
    <span :class="$style.paymentTerms">
      <span
        v-if="
          paymentTerms &&
          paymentTerms.length === 1 &&
          paymentTerms[0].code === customBasketAttributes.productOrderPaymentTarget
        "
      >
        {{ paymentTerms[0].text }}
      </span>
      <v-select
        v-else
        :disabled="pending || !(paymentTerms && paymentTerms.length)"
        hide-details
        :class="$style.select"
        :items="paymentTerms"
        :label="$t('checkout.payment.label')"
        item-value="code"
        item-text="text"
        dense
        :value="customBasketAttributes.productOrderPaymentTarget"
        @input="
          updateProduct(
            'ProductOrderPaymentTarget',
            $event,
            selfUrl,
            amount,
            customBasketAttributes,
          )
        "
      ></v-select
    ></span>
    <!-- :label="miniBasket ? $t('checkout.payment.label') : undefined" ==== NOTES: Removed from line 14. above to display minibasket in Checkout page as well -->
    <span v-if="deliveryTerms.length" :class="$style.deliveryType">
      <BasketDeliverySwitch
        v-show="deliveryTerms.length > 1"
        :class="$style.switch"
        :true-value="deliveryStates.EXPRESS"
        :false-value="deliveryStates.DEFAULT"
        :disabled="pending"
        :value="customBasketAttributes.productOrderDelivery || deliveryStates.DEFAULT"
        :label-translation-prefix="
          miniBasket || isMobile ? 'checkout.delivery.mini.types.' : 'checkout.delivery.types.'
        "
        @change="
          updateProduct('ProductOrderDelivery', $event, selfUrl, amount, customBasketAttributes)
        "
      />
    </span>
    <!-- :label-translation-prefix="
          miniBasket ? 'checkout.delivery.mini.types.' : 'checkout.delivery.types.'
        " ==== NOTES: Removed from line 41 - 43. above to display minibasket in Checkout page as well -->
    <!-- <span v-if="!miniBasket" :class="$style.deliveryTermsCheckout">Express: </span> -->
  </li>
</template>

<script>
import { DELIVERY_TERMS } from '@/js/helper/delivery-constants.js'
import BasketDeliverySwitch from '@/js/components/Basket/BasketDeliverySwitch.vue'

export default {
  name: 'BasketProductSplitItem',
  components: { BasketDeliverySwitch },
  props: {
    type: {
      type: String,
      default: '',
    },
    splitKey: {
      type: String,
      default: undefined,
    },
    miniBasket: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: String,
      default: '',
    },
    amount: {
      type: Number,
      default: 0,
    },
    selfUrl: {
      type: String,
      default: undefined,
    },
    paymentTerms: {
      type: Array,
      default: () => [],
    },
    deliveryTerms: {
      type: Array,
      default: () => [],
    },
    customBasketAttributes: {
      type: Object,
      default: () => ({}),
    },
    basketStatus: {
      type: String,
      default: undefined,
    },
    basketStatusIsOk: {
      type: Boolean,
      default: false,
    },
    splitType: {
      type: String,
      default: undefined,
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deliveryStates: DELIVERY_TERMS,
    }
  },
  methods: {
    updateProduct(type, e, selfUrl, quantity, customBasketAttributes) {
      if (this.splitType) {
        customBasketAttributes[this.splitType] = this.splitKey
      }
      this.$emit('updateBasketItem', {
        productId: this.productId,
        type,
        value: e,
        selfUrl,
        quantity,
        customBasketAttributes,
      })
    },
  },
}
</script>

<style lang="scss" module>
.containerMini {
  .paymentTerms {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      margin-top: 0;
      padding-right: 1.25rem;
      padding-left: 1rem;

      .deliveryType {
        justify-self: end;
      }
    }
    margin-top: 1rem;
    padding-right: 0;
    padding-left: 0;
  }

  .deliveryType {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      justify-self: end;
    }

    justify-self: start;
  }
}

.type {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    align-self: auto;
    margin-right: 0;
  }
  grid-area: type;
  align-self: flex-start;
  margin-right: 0.5rem;
}

.paymentTerms {
  grid-area: payment;
}

.paymentTerms {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    :global(.v-input .v-label) {
      display: none;
    }
  }

  :global(.v-input .v-label) {
    font-weight: bold;
    font-size: 1.13rem;
  }
}

.deliveryType {
  grid-area: delivery;
}

.basketmessage {
  grid-area: message;

  color: var(--error);
  font-size: 0.75rem;
  line-height: 0.875rem;
}

.select {
  padding-top: 0.5rem;
}

.type,
.amount,
.select,
.switch :global(.v-label) {
  font-weight: normal;
  font-size: 0.875rem;
}

.switch {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    :global(.v-label) {
      flex: 1 1 auto !important;
      justify-content: end;
    }

    :global(.v-input__slot) {
      flex-direction: row;
      flex-wrap: unset;
      justify-content: center;
      margin-right: 0;
    }
  }

  :global(.v-label) {
    flex: inherit !important;

    justify-content: flex-end;
    margin-right: 1rem;

    font-weight: bold;
  }

  :global(.v-input__slot) {
    flex-direction: row-reverse;
    flex-wrap: wrap-reverse;
    justify-content: flex-end;
  }

  :global(.v-input--selection-controls__input) {
    margin-right: 0 !important;
  }
}

.amount {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    text-align: right;
  }
  grid-area: quantity;

  text-align: left;
}

.quantityLabel {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    display: none;
  }
  grid-area: quantityLabel;

  font-weight: bold;
  font-size: 0.875rem;
}
</style>
